/// <amd-module name="TFS/Admin/Groups/Pivots/Users/Redux/UsersPivotActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { UsersOperation, CustomGraphUser } from "TFS/Admin/Groups/Common/Contracts";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { SearchStatus, IPermissionPage } from "TFS/Admin/Groups/Common/Constants";

/**
 * Actions for Users view
 */
export const UsersPivotActions = {
    initView: (scopeDescriptor?: string, permissionPage?: IPermissionPage) =>
        createAction(UsersPivotActionTypes.InitView, { scopeDescriptor, permissionPage }),
    disposeView: () => createAction(UsersPivotActionTypes.DisposeView),
    initialUsersLoadSucceeded: (users: CustomGraphUser[], continuationToken?: string[]) =>
        createAction(UsersPivotActionTypes.InitialUsersLoadSucceeded, { users, continuationToken }),
    usersLoadFailed: () => createAction(UsersPivotActionTypes.UsersLoadFailed),
    fetchMoreUsersSucceeded: (users: CustomGraphUser[], continuationToken?: string[]) =>
        createAction(UsersPivotActionTypes.FetchMoreUsersSucceeded, { users, continuationToken }),
    onRenderMissingItem: (continuationToken?: string[], scopeDescriptor?: string, permissionPage?: IPermissionPage) =>
        createAction(UsersPivotActionTypes.OnRenderMissingItem, { continuationToken, scopeDescriptor, permissionPage }),
    userOperationStatus: (operation: UsersOperation, resultMessage: string, severity: MessageCardSeverity) =>
        createAction(UsersPivotActionTypes.UserOperationStatus, { operation, resultMessage, severity }),
    onDismissMessageCard: () => createAction(UsersPivotActionTypes.DismissMessageCard),

    // Search
    searchUsers: (
        newKeyword?: string,
        oldKeyword?: string,
        scopeDescriptor?: string,
        isExpandSearchToOrg?: boolean,
        permissionPage?: IPermissionPage
    ) => createAction(UsersPivotActionTypes.SearchUsers, { newKeyword, oldKeyword, scopeDescriptor, isExpandSearchToOrg, permissionPage }),
    updateSearchStatus: (searchStatus: SearchStatus) => createAction(UsersPivotActionTypes.UpdateSearchStatus, searchStatus),
    updateSearchResult: (keyword: string, result: any[], hasMore: boolean) =>
        createAction(UsersPivotActionTypes.UpdateSearchResult, { result, hasMore, keyword })
};

export const enum UsersPivotActionTypes {
    InitView = "UsersPivot/Init",
    DisposeView = "UsersPivot/Dispose",
    InitialUsersLoadSucceeded = "UsersPivot/InitialUsersLoadSucceeded",
    UsersLoadFailed = "UsersPivot/UsersLoadFailed",
    FetchMoreUsersSucceeded = "UsersPivot/FetchMoreUsersSucceeded",
    OnRenderMissingItem = "UsersPivot/OnRenderMissingItem",
    UserOperationStatus = "UsersPivot/UserOperationStatus",
    DismissMessageCard = "UsersPivot/DismissMessageCard",

    // Search
    SearchUsers = "UsersPivot/SearchUsers",
    UpdateSearchStatus = "UsersPivot/UpdateSearchStatus",
    UpdateSearchResult = "UsersPivot/UpdateSearchResult"
}

export type UsersPivotActions = ActionsUnion<typeof UsersPivotActions>;
